import { CommentAnnotationElement } from './ui'

import { AnnotationPlugin } from '@st/document-viewer-kit'
import { match, P } from '@st/pattern'
import { CommentToolState } from '~/st-doc-viewer/annotations'
import { CommentToolOverlay } from './ui'
import type { ViewerCommentAnnotation } from '../../viewer-annotations'

export function commentToolPlugin(): AnnotationPlugin<ViewerCommentAnnotation, CommentToolState> {
  return {
    name: 'comment',
    initialToolState: {
      name: 'comment',
      settings: {}
    },
    ToolOverlay: CommentToolOverlay,
    Element: CommentAnnotationElement,
    handlesAnnotation: (annotation) => annotation.type == 'comment',
    onAnnotationDeselected: (event) =>
      match(event)
        // Empty comments are not persisted, whether the draft is new or edits an existing comment.
        .with({ annotationDraft: { content: '' } }, ({ annotationDraft }) => ({
          type: 'discardAnnotationDraft' as const,
          annotationId: annotationDraft.id
        }))
        .with({ annotationDraft: P.nonNullable }, ({ annotationDraft }) => ({
          type: 'commitAnnotationDraft' as const,
          annotationDraft
        }))
        // Without a draft, deselection has nothing to persist.
        .otherwise(() => null)
  }
}
